import { Component } from '@angular/core';
import {AlertController, Events, ModalController, NavController, NavParams, ToastController} from "ionic-angular";
import {ApplicationVariables, Constants, isIntelliStock} from "../../providers/config";
import {Api} from "../../providers/api";
import {CartManager} from "../../providers/cart-manager";
import {ArrayUtils} from "../../utils/array-utils";
import {MsgManager} from "../../providers/msg-manager";
import {ApiOffline} from "../../providers/api-offline";
import {ShipmentcartManagerProvider} from "../../providers/shipmentcart-manager";
import {Storage} from "@ionic/storage";
import {GVLogger} from "../../services/gv-logger";
import {CART, loginUserInfo, STOCKCART} from "../../providers/data";
import {ItemsPage} from "../items/items";
import {CartPage} from "../cart/cart";
import {OrderViewPage} from "../order-view/order-view";
import {Headers, RequestOptions} from "@angular/http";
import {LoginPage} from "../login/login";
import * as moment from "moment";
// import * as timeZone from "*";
import {SearchPage} from "../search/search";
import {PickPackParamsPage} from "../pickpackparams/pickpackparams";
import {PickpacklistPage} from "../pickpacklist/pickpacklist";
import {ConfirmShipmentPage} from "../confirm-shipment/confirm-shipment";
import {ReturnShipmentPage} from "../return-shipment/return-shipment";
import {ReturncartManager} from "../../providers/returncart-manager";
import {MyOrderPage} from "../my-order/my-order";
import {ThankYouModalPage} from "../thank-you-modal/thank-you-modal";
import {LicenseStatusModelPage} from "../license-status-model/license-status-model";

@Component({
  selector: 'page-approve-return',
  templateUrl: 'approve-return.html',
})
export class ApproveReturnPage {

  public orders: any =  [];
  public allDataLoaded = false;
  public constants = Constants;
  cart:any;
  isOfflineMode = false;
  loggedInUserWarehouse = loginUserInfo.assignedWarehouseName

  adpCustomerInfo : any = {};

  ad:any = {  };

  offlineOrdersAvailable = false;
  showAds = 0;
  isIntelliStockfunc = isIntelliStock;
  stockCart: any;

  enteredOrderNumber = "";
  enteredProductBarcode = "";
  shipmentsData = [];
  // order;
 ordersList = [];
 returnButtonStatus = false;
 isLoading = false;

  constructor(public nav: NavController,
              public api:Api,
              public returnCartManager:ReturncartManager,
              public arrayUtils:ArrayUtils,
              public alertCtrl:AlertController,
              private msgManager:MsgManager,
              private toastCtrl:ToastController,
              private apiOffline:ApiOffline,
              private events:Events,
              private modalCtrl:ModalController,
              private shipmentCartManager:ShipmentcartManagerProvider,
              private cartManager:CartManager,
              public storage:Storage,
              private gVLogger: GVLogger) {

    // this.gVLogger.log("constructor called of my order : ");
    // this.adpCustomerInfo = this.cartManager.getAdpCustomerInfo();
    // set sample data
    //this.orders = orderService.getAll();

    // this.isOfflineMode = ApplicationVariables.isOffline;

    // IntelliRep Browser Check
    // if(!Constants.isWebstore && Constants.IntelliStockRunningIn === "NA" && Constants.IntelliRepRunningIn == "App"){
    //   this.checkOfflineOrders();
    // }


    // this.events.subscribe("SyncCompleted",()=>{
    //   // IntelliRep Browser Check
    //   if(!Constants.isWebstore && Constants.IntelliStockRunningIn === "NA" && Constants.IntelliRepRunningIn == "App"){
    //     this.checkOfflineOrders();
    //   }
    //   this.getOrdersResolver(0);
    // });

    // this.getShowAds();



    // this.getOrdersResolver(0);

    this.cart = this.returnCartManager.getItems();
    // this.stockCart = STOCKCART;

  }

  findSipmentsByOrderId(){

    if(this.enteredOrderNumber !== ""){
      this.gVLogger.log("shipments calledddddddd : ");
      var url = "/order/getOrderById";
      var body = "?orderId="+this.enteredOrderNumber;
      var shipmentAvail = false;
      this.api.post(url+body,null).map(res => res.json()).subscribe(data => {
        this.gVLogger.log("data from /products/getOrderById : " + data);
        if(data.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

          this.nav.setRoot(LoginPage);
        }
        if(data.status === "200" && data.data.length > 0) {
          this.shipmentsData = [];

          // this.ordersList = data.data;

          for(let index of data.data) {
            this.gVLogger.log("index for loop in shipments + " + JSON.stringify(index))

            // this.shipmentsData.push(index);
            this.returnCartManager.addProductToCart(index);

            // }
          }

        }
        else {
          this.msgManager.toastMsg("No Shipment Found Against Order Id: " + this.enteredOrderNumber);
          this.shipmentsData = [];
          // this.shipmentsAvailabilityCheck = true;
        }
      });
    }else if (this.enteredProductBarcode !== ""){
      this.gVLogger.log("shipments calledddddddd : ");
      var url = "/order/getOrderByProductId";
      var body = "?productBarCode="+this.enteredProductBarcode;
      var shipmentAvail = false;
      this.api.post(url+body,null).map(res => res.json()).subscribe(data => {
        this.gVLogger.log("data from /products/getOrderById : " + data);
        if(data.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

          this.nav.setRoot(LoginPage);
        }
        if(data.status === "200" && data.data.length > 0) {
          this.shipmentsData = [];

          // this.ordersList = data.data;

          for(let index of data.data) {
            this.gVLogger.log("index for loop in shipments + " + JSON.stringify(index))

            // this.shipmentsData.push(index);
            this.returnCartManager.addProductToCart(index);
            // }
          }

        }
        else {
          this.msgManager.toastMsg("No Shipment Found Against Product scan code: " + this.enteredProductBarcode);
          this.shipmentsData = [];
          // this.shipmentsAvailabilityCheck = true;
        }
      });
    }

  }

  shipmentDetails(shipment){
      this.gVLogger.log("tap called..." + JSON.stringify(shipment));
      // var url = "/order/loadShipment";
      // var body = "?orderId="+shipment.shipmentNoticeByNoticesId.poNo+"&shipmentId="+shipment.shipmentNoticeByNoticesId.id;
      // this.api.post(url+body,null).map(res => res.json()).subscribe(data => {
        // if(data.status === "200") {
          let orderPickPackList = shipment.ordersDTO;
          let orderView = orderPickPackList;


          let productsList: any = [];
          let productsListForShipment: any = [];
          for(let orderDetail of shipment.shipmentDTOList.orderDetailShipmentDTOS){
            let product: any = orderDetail.productsDTO;
            productsList.push(product);
          }
          let cart:any = {};

          this.gVLogger.log(orderPickPackList);

          cart.customer = orderPickPackList.customerDTO;
          cart.orderMessage = orderPickPackList.orderMessage;
          cart.expectedShipmentDate = orderPickPackList.expectedShipmentDate;
          cart.shippingServiceName = orderPickPackList.shippingServiceName;
          cart.shippingServiceId = orderPickPackList.shippingServiceValue;
          cart.orderId = orderPickPackList.id;
          cart.items = productsList;
          // cart.items = this.shipmentCartManager.getItems();
          cart.orderStatus = orderPickPackList.orderStatus;
          cart.orderTitle = orderPickPackList.orderTitle;

          this.nav.push(ReturnShipmentPage,{"cart":cart,"TotalPrice":orderPickPackList.totalAmount, "orderView" : orderView, "pageStatus" : "shipment", "plannedShipmentDate" : shipment.shipmentDTOList.plannedShipmentDate, "shipmentNo" : shipment.shipmentNoticeByNoticesId.shipmentNo});
        // }
        // else {
        //   this.gVLogger.log("else calledd with shipmentDetails ");
        // }
      // });
      // setTimeout(() => {
      //   this.productLocationDisplayStatus = true;
      // },1000)
    // }
  }


  resetSipment(){
    let confirm = this.alertCtrl.create({
      title: 'Discard Returns!',
      message: 'Do you want to discard the selected products for return?',
      buttons: [
        {
          text: 'Cancel',
          handler: () => {
            //  this.gVLogger.log('Disagree clicked');
          }
        },
        {
          text: 'Agree',
          handler: () => {

            this.returnCartManager.clearCart();
            this.nav.setRoot(ApproveReturnPage);
          }
        },
      ]
// }


    });
    confirm.present();

  }


  confirmShipment() {

    let confirm = this.alertCtrl.create({
      title: 'Confirm Products Return!',
      message: 'Do you approve the returns? This will create a return notice for receiving returned products',
      buttons: [
        {
          text: 'Cancel',
          handler: () => {

          }
        },
        {
          text: 'Agree',
          handler: () => {

            this.returnButtonStatus = true;
            this.isLoading = true;



            this.api.getADPPay("feature/getLicenseStatus?customerUUID="+this.cartManager.getADPCustomerUUID() + "&featureAlias="+ this.constants.Monthly_License_alias+"&consumptionCount=0").map(res => res.json())
              .subscribe(data => {
                if(data.status === 570 || data.status === 571 || data.status === 403){
                  this.presentPaySatusAlert("Failure", data.message);
                  this.returnButtonStatus = false;
                  this.isLoading = false;
                }
                else if(data.status === 200 || data.status === 270) {

                  let bodyArray = [];

                  for(let cartItems of this.cart){
                    var body: any = this.cartManager.returnShipment(1, cartItems, cartItems.ordersDTO, cartItems.shipmentNoticeByNoticesId.shipmentNo, cartItems.ordersDTO.plannedShipmentDate); // placeorder status 1
                    bodyArray.push(body);
                  }
                  let headers = new Headers({
                    'Content-Type': 'application/json'
                  });
                  let options = new RequestOptions({
                    headers: headers
                  });

                  this.api.post("order/returnShipment", JSON.stringify(bodyArray), options)
                    .map(res => res.json())
                    .subscribe(resp => {
                        if (resp.status == "200") {


                          this.returnCartManager.clearCart();
                          this.presentThankYouAlert("Returned product notice confirmed!", "Please note that the quantities shipped have been adjusted from the quantities on hand inside the system.");

                          this.nav.setRoot(ApproveReturnPage).then(() => {
                          });
                        } else if (resp.status == "401") { // check for session out
                          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

                          this.nav.setRoot(LoginPage);
                        }

                      }
                      , error => {
                        this.msgManager.toastMsg(this.msgManager.getOrderPlaceFailMsg());
                        this.returnButtonStatus = false;
                        this.isLoading = false;
                      });
                }

              });


          }
        },
      ]

    });
    confirm.present();
  }

  presentThankYouAlert(title,msg){
    let thankyouModal = this.modalCtrl.create(ThankYouModalPage, { title: title ,message: msg });
    thankyouModal.present();
  }

  presentPaySatusAlert(title,msg){
    this.gVLogger.log("LicenseStatusModelPage");
    let thankyouModal = this.modalCtrl.create(LicenseStatusModelPage, { title: title ,message: msg });
    thankyouModal.present();
  }



  // getOrdersResolver(itemCount){
  //   this.gVLogger.log("get order resolver method : ");
  //   // IntelliRep Browser Check
  //   if(ApplicationVariables.isOffline && Constants.IntelliStockRunningIn === "NA" && Constants.IntelliRepRunningIn == "App"){
  //
  //     this.orders = [];
  //     this.getOrdersOffline();
  //   }else{
  //     this.getOrdersLazy(itemCount);
  //     if(itemCount == 0){
  //       // IntelliRep Browser Check
  //       if(!Constants.isWebstore && Constants.IntelliStockRunningIn === "NA" && Constants.IntelliRepRunningIn == "App"){
  //         this.getOrdersOffline();
  //       }
  //       // this.getOrdersOffline();
  //     }
  //   }
  // }

  getOrdersOffline(){
    //this.orders = [];
    this.apiOffline.getAllOrders().then((res)=>{
      for(var i=0; i<res.rows.length; i++)
      {
        var json = JSON.parse(res.rows.item(i).json);
        this.orders.unshift(json);
      }
    },err=>{
      // alert(JSON.stringify(err));
    });
  }



  // getOrdersLazy(itemCount){
  //   this.gVLogger.log("get products lazy function method : " + itemCount);
  //
  //   return new Promise(resolve=>{
  //     var ordersListCount = itemCount;
  //
  //     var body = "?userId="+this.cartManager.getSalesManId()+"&startPoint="+ ordersListCount;
  //     if(Constants.isWebstore){
  //       body = "?customerId="+this.cartManager.getCustomerID()+"&startPoint="+ ordersListCount;
  //     }
  //
  //     let headers = new Headers({
  //       'Content-Type': 'application/json'
  //     });
  //     let options = new RequestOptions({
  //       headers: headers
  //     });
  //
  //     var url = "order/loadByUser";
  //     if(Constants.isWebstore){
  //       url = "order/loadByCustomer";
  //     }
  //
  //     this.api.post(url+body,null)
  //       .map(res=> res.json())
  //       .subscribe(data=>{
  //         if(data.status == "401"){ // check for session out
  //           this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
  //           this.nav.setRoot(LoginPage);
  //         }else if(data.status == 200){
  //           var temp = this.orders;
  //
  //
  //           for(let order of data.data){
  //             this.gVLogger.log("Recived : "+order.updatedAt);
  //             temp.push(order);
  //           }
  //
  //           this.orders = this.arrayUnique(temp);
  //           if(data.data == []){
  //             this.allDataLoaded = true;
  //           }
  //           resolve(true);
  //         }
  //       });
  //
  //   });
  // }


  // doInfinite(infiniteScroll){
  //   var arrayLength = this.orders.length;
  //   this.getOrdersLazy(arrayLength).then(()=>{
  //     infiniteScroll.complete();
  //   });
  //
  //
  // }

  arrayUnique(array) {
    var a = array.concat();
    for(var i=0; i<a.length; ++i) {
      for(var j=i+1; j<a.length; ++j) {
        if(a[i] === a[j])
          a.splice(j--, 1);
      }
    }

    return a;
  }


  decimalLengthFixed(num,max){
    if(num !== undefined)
      return Number(num).toFixed(Math.max(2, (num.toString().split('.')[1] || []).length))
  }




  gotoItemsPage(){
    this.nav.setRoot(ItemsPage);
  }

  logOut(){
    this.nav.setRoot(LoginPage);
  }

  goToCart(){
    this.nav.push(CartPage);

  }

  goToSearch(){
    this.nav.push(SearchPage);
  }






  presentToast(msg){
    var toast = this.toastCtrl.create(
      {
        message:msg,
        duration: 3000,
        position: 'bottom'
      }
    );
    toast.present();
  }


  checkOfflineOrders(){
    this.apiOffline.getAllOrders().then((res)=>{
      if(res.rows.length>0)
      {
        this.offlineOrdersAvailable = true;
      }else{
        this.offlineOrdersAvailable = false;
      }
    });
  }


  syncOrders(){
    this.apiOffline.syncOrdersToServer();
  }

  // getShowAds(){
  //
  //   if(this.cartManager.getAdpCustomerInfo().showAds == 1){
  //     this.getAdByRoleId();
  //   }
  // }

  // getAdByRoleId(){
  //   this.api.get("/adByRoleId/"+this.cartManager.getSalesPerson().roleId)
  //     .map(res=>res.json())
  //     .subscribe(result=>{
  //       this.ad = result.data;
  //       if(this.ad.adText.trim() !== "" ){
  //         this.showAds = 1;
  //       }
  //     });
  //
  // }

  enteredOrderNumberChanged(){
    this.enteredProductBarcode = "";
  }

  enteredProductBarcodeChanged(){
    this.enteredOrderNumber = "";
  }




}



// WEBPACK FOOTER //
// ./src/pages/approve-return/approve-return.ts